/*!
 * Ambaroud — Maison theme runtime.
 * Header, reveals, cursor, rails, cart drawer (free-shipping flacon + multi-bottle ladder),
 * product experience, scent finder, collection filtering, predictive search.
 */
(function () {
  'use strict';
  var C = window.AmbCfg || {};
  C.routes = C.routes || {};
  C.tiers = C.tiers || [];
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mm = function (q) { return window.matchMedia ? matchMedia(q).matches : false; };
  var reduce = mm('(prefers-reduced-motion: reduce)');
  var fine = mm('(hover: hover) and (pointer: fine)');
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var raf = function (fn) { return window.requestAnimationFrame(fn); };
  var ARROW = '<svg class="arrow" viewBox="0 0 18 10" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M0 5h17M12.5 1 17 5l-4.5 4"/></svg>';
  var STAR = '<svg class="star8" viewBox="0 0 100 100" fill="currentColor"><path d="M50 0l11 26 24-11-11 24 26 11-26 11 11 24-24-11-11 26-11-26-24 11 11-24L0 50l26-11-11-24 24 11z"/></svg>';
  var PLUS = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M7 1v12M1 7h12"/></svg>';

  /* ---------------- money ---------------- */
  function money(cents, noZeros) {
    cents = typeof cents === 'string' ? Math.round(parseFloat(cents) * (cents.indexOf('.') > -1 ? 100 : 1)) : Number(cents) || 0;
    var fmt = C.moneyFormat || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var style = m ? m[1] : 'amount';
    function f(n, d, ts, ds) {
      var v = (n / 100).toFixed(d), parts = v.split('.');
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? i + ds + parts[1] : i;
    }
    var val;
    switch (style) {
      case 'amount_no_decimals': val = f(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = f(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = f(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = f(cents, 2, "'", '.'); break;
      default: val = f(cents, 2, ',', '.');
    }
    if (noZeros) val = val.replace(/[.,]00$/, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------------- helpers ---------------- */
  function lock(on) { document.body.classList.toggle('is-locked', !!on); }
  var toastT;
  function toast(msg) {
    var t = $('.amb-toast'); if (!t) return;
    t.innerHTML = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  function tween(from, to, dur, cb) {
    if (reduce) { cb(to); return; }
    var s = performance.now();
    (function step(n) {
      var k = clamp((n - s) / dur, 0, 1), e = 1 - Math.pow(1 - k, 4);
      cb(from + (to - from) * e);
      if (k < 1) raf(step);
    })(s);
  }
  function jfetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Something went wrong'); e.data = j; throw e; }
        return j;
      });
    });
  }

  /* ---------------- catalogue data (for finder + upsells) ---------------- */
  var dataP;
  function catalogue() {
    if (dataP) return dataP;
    try {
      var cached = sessionStorage.getItem('amb-data-v1');
      if (cached) { var o = JSON.parse(cached); if (Date.now() - o.t < 30 * 60 * 1000) { dataP = Promise.resolve(o.d); return dataP; } }
    } catch (e) {}
    dataP = fetch(C.dataUrl || '/collections/all?view=amb-data').then(function (r) { return r.text(); }).then(function (t) {
      var d = JSON.parse(t.slice(t.indexOf('['), t.lastIndexOf(']') + 1));
      try { sessionStorage.setItem('amb-data-v1', JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    }).catch(function () { return []; });
    return dataP;
  }

  /* ---------------- intro ---------------- */
  function intro() {
    var h = document.documentElement;
    if (!h.classList.contains('intro-on')) return;
    var done = false;
    function out() {
      if (done) return; done = true;
      h.classList.add('intro-out');
      try { sessionStorage.setItem('ambIntro', '1'); } catch (e) {}
      setTimeout(function () { h.classList.remove('intro-on', 'intro-out'); }, 1150);
    }
    setTimeout(out, 1850);
    $('.amb-intro') && $('.amb-intro').addEventListener('click', out);
  }

  /* ---------------- header ---------------- */
  function header() {
    var h = $('[data-hdr]'); if (!h) return;
    var root = document.documentElement, last = scrollY, ticking = false;
    function setH() { root.style.setProperty('--hdr-h', h.offsetHeight + 'px'); }
    setH(); window.addEventListener('resize', setH, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(setH).observe(h);
    function onScroll() {
      var y = scrollY;
      h.classList.toggle('is-scrolled', y > 40);
      if (!h.classList.contains('mega-open')) {
        if (y > 420 && y > last + 6) h.classList.add('is-hidden');
        else if (y < last - 6 || y < 420) h.classList.remove('is-hidden');
      }
      document.body.classList.toggle('hdr-visible', !h.classList.contains('is-hidden') && y > 40);
      last = y;
      var max = root.scrollHeight - innerHeight;
      root.style.setProperty('--sp', max > 0 ? (y / max).toFixed(4) : 0);
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(onScroll); } }, { passive: true });
    onScroll();

    var scrim = $('.mega-scrim'), closeT, trig = $$('[data-mega]', h), panes = $$('[data-mega-pane]', h);
    function open(id) {
      clearTimeout(closeT);
      h.classList.add('mega-open'); scrim && scrim.classList.add('is-on');
      panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-pane') === id); });
      trig.forEach(function (t) { var on = t.getAttribute('data-mega') === id; t.parentNode.classList.toggle('is-active', on); t.setAttribute('aria-expanded', on); });
    }
    function close(now) {
      clearTimeout(closeT);
      closeT = setTimeout(function () {
        h.classList.remove('mega-open'); scrim && scrim.classList.remove('is-on');
        trig.forEach(function (t) { t.parentNode.classList.remove('is-active'); t.setAttribute('aria-expanded', 'false'); });
      }, now ? 0 : 180);
    }
    trig.forEach(function (t) {
      t.addEventListener('mouseenter', function () { open(t.getAttribute('data-mega')); });
      t.addEventListener('focus', function () { open(t.getAttribute('data-mega')); });
      t.addEventListener('click', function (e) {
        if (!fine && !h.classList.contains('mega-open')) { e.preventDefault(); open(t.getAttribute('data-mega')); }
      });
    });
    $$('.hdr__nav a:not([data-mega]), .hdr__right a, .hdr__right button, .hdr__logo', h).forEach(function (a) { a.addEventListener('mouseenter', function () { close(); }); });
    var mega = $('.mega', h);
    if (mega) { mega.addEventListener('mouseenter', function () { clearTimeout(closeT); }); }
    h.addEventListener('mouseleave', function () { close(); });
    scrim && scrim.addEventListener('click', function () { close(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    $$('[data-prev]', h).forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var pane = a.closest('[data-mega-pane]'), id = a.getAttribute('data-prev');
        $$('.mega__preview img', pane).forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-for') === id); });
        $$('[data-prev]', pane).forEach(function (x) { x.classList.toggle('is-hover', x === a); });
      });
    });

    var mn = $('[data-mnav]');
    if (mn) {
      function mOpen() { mn.classList.add('is-open'); mn.setAttribute('aria-hidden', 'false'); lock(true); setTimeout(function () { var c = $('[data-menu-close]', mn); c && c.focus(); }, 350); window.AmbGL && AmbGL.scan(mn); }
      function mClose() { mn.classList.remove('is-open'); mn.setAttribute('aria-hidden', 'true'); lock(false); }
      $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', mOpen); });
      $$('[data-menu-close]', mn).forEach(function (b) { b.addEventListener('click', mClose); });
      $$('.mnav__row[aria-expanded]', mn).forEach(function (b) {
        b.addEventListener('click', function () { b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') !== 'true'); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mn.classList.contains('is-open')) mClose(); });
    }
  }

  /* ---------------- split + reveal ---------------- */
  function split(el) {
    if (el.classList.contains('is-split')) return;
    var i = 0;
    (function walk(node, inEm) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (pt) {
            if (!pt) return;
            if (/^\s+$/.test(pt)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w';
            var s = document.createElement('span'); s.textContent = pt; s.style.setProperty('--i', i++);
            if (inEm) s.className = 'gw';
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n, inEm || n.tagName === 'EM');
      });
    })(el, false);
    el.classList.add('is-split');
  }
  var revealIO;
  function reveals(root) {
    root = root || document;
    $$('[data-split]', root).forEach(split);
    $$('[data-stagger]', root).forEach(function (g) {
      var step = parseInt(g.getAttribute('data-stagger'), 10) || 90;
      $$('[data-reveal]', g).forEach(function (el, i) { if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', (i % 8) * step); });
    });
    if (!('IntersectionObserver' in window) || reduce) { $$('[data-reveal],[data-split],[data-inview]', root).forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    $$('[data-reveal]:not(.is-in),[data-split]:not(.is-in),[data-inview]:not(.is-in)', root).forEach(function (e) { revealIO.observe(e); });
  }

  /* ---------------- scroll-linked: parallax, manifesto, footer, pdp ---------------- */
  var scrollers = [];
  function onScrollFx(fn) { scrollers.push(fn); }
  (function () {
    var ticking = false;
    function run() { ticking = false; for (var i = 0; i < scrollers.length; i++) scrollers[i](); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(run); } }, { passive: true });
    window.addEventListener('resize', function () { raf(run); }, { passive: true });
    window.__ambRunScroll = run;
  })();
  function parallax() {
    if (reduce) return;
    var els = $$('[data-parallax]'); if (!els.length) return;
    onScrollFx(function () {
      var vh = innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
        var f = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var off = (r.top + r.height / 2 - vh / 2) * f;
        el.style.translate = '0 ' + off.toFixed(1) + 'px';
      });
    });
  }
  function manifesto() {
    $$('[data-mani]').forEach(function (el) {
      if (!el.__mw) {
        var words = [];
        (function walk(node, gold) {
          Array.prototype.slice.call(node.childNodes).forEach(function (n) {
            if (n.nodeType === 3) {
              var frag = document.createDocumentFragment();
              n.textContent.split(/(\s+)/).forEach(function (pt) {
                if (!pt) return;
                if (/^\s+$/.test(pt)) { frag.appendChild(document.createTextNode(' ')); return; }
                var s = document.createElement('span'); s.className = 'mw' + (gold ? ' is-gold' : ''); s.textContent = pt; frag.appendChild(s); words.push(s);
              });
              n.parentNode.replaceChild(frag, n);
            } else if (n.nodeType === 1) walk(n, gold || n.tagName === 'EM');
          });
        })(el, false);
        el.__mw = words;
      }
      onScrollFx(function () {
        var r = el.getBoundingClientRect(), vh = innerHeight;
        var p = clamp((vh * 0.82 - r.top) / (r.height + vh * 0.3), 0, 1);
        var lit = Math.round(p * el.__mw.length * 1.08);
        el.__mw.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); });
      });
    });
  }
  function footerWord() {
    var w = $('[data-fill]'); if (!w) return;
    onScrollFx(function () {
      var r = w.getBoundingClientRect(), vh = innerHeight;
      var p = clamp((vh - r.top) / (r.height + vh * 0.35), 0, 1);
      w.style.setProperty('--fill', (p * 100).toFixed(1) + '%');
    });
  }

  /* ---------------- cursor + magnetic + tilt ---------------- */
  function cursor() {
    if (!fine || reduce || !C.cursor) return;
    var el = $('.amb-cursor'); if (!el) return;
    document.documentElement.classList.add('has-cursor');
    var dot = $('.amb-cursor__dot', el), ring = $('.amb-cursor__ring', el), label = $('em', ring);
    var x = -100, y = -100, rx = x, ry = y;
    window.addEventListener('pointermove', function (e) { x = e.clientX; y = e.clientY; dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)'; }, { passive: true });
    (function loop() { rx += (x - rx) * 0.2; ry += (y - ry) * 0.2; ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)'; raf(loop); })();
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('[data-cursor],a,button,summary,label,select,input,textarea');
      var lab = t && t.getAttribute('data-cursor');
      el.classList.toggle('is-label', !!lab); el.classList.toggle('is-link', !!t && !lab);
      label.textContent = lab || '';
    });
    document.documentElement.addEventListener('pointerleave', function () { document.documentElement.classList.add('amb-cursor-hidden'); });
    document.documentElement.addEventListener('pointerenter', function () { document.documentElement.classList.remove('amb-cursor-hidden'); });
  }
  function magnetic(root) {
    if (!fine || reduce) return;
    $$('[data-magnetic]', root).forEach(function (b) {
      if (b.__mag) return; b.__mag = 1;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }
  function tilt() {
    if (!fine || reduce) return;
    $$('[data-tilt-stage]').forEach(function (st) {
      var items = $$('[data-depth]', st), tx = 0, ty = 0, cx = 0, cy = 0, on = false;
      st.closest('section').addEventListener('pointermove', function (e) {
        var r = st.getBoundingClientRect();
        tx = clamp((e.clientX - r.left) / r.width - 0.5, -0.7, 0.7); ty = clamp((e.clientY - r.top) / r.height - 0.5, -0.7, 0.7);
        if (!on) { on = true; loop(); }
      });
      function loop() {
        cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        items.forEach(function (it) {
          var d = parseFloat(it.getAttribute('data-depth')) || 1;
          it.style.transform = 'translate3d(' + (cx * 34 * d).toFixed(1) + 'px,' + (cy * 26 * d).toFixed(1) + 'px,0) rotateY(' + (cx * 10 * d).toFixed(2) + 'deg) rotateX(' + (-cy * 8 * d).toFixed(2) + 'deg)';
        });
        if (Math.abs(tx - cx) + Math.abs(ty - cy) > 0.001) raf(loop); else on = false;
      }
    });
  }

  /* ---------------- horizontal rails ---------------- */
  function rails() {
    $$('[data-hscroll]').forEach(function (sec) {
      var track = $('[data-hscroll-track]', sec), meter = $('.rail__meter', sec), dist = 0;
      if (!track) return;
      function setup() {
        var ok = mm('(min-width: 900px) and (hover: hover)') && !reduce && track.children.length > 3;
        sec.classList.toggle('is-pinned', ok);
        if (!ok) { sec.style.height = ''; track.style.transform = ''; return; }
        dist = Math.max(0, track.scrollWidth - innerWidth);
        sec.style.height = (innerHeight + dist) + 'px';
      }
      function upd() {
        var p;
        if (sec.classList.contains('is-pinned')) {
          var r = sec.getBoundingClientRect();
          p = clamp(-r.top / Math.max(1, r.height - innerHeight), 0, 1);
          track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px,0,0)';
        } else {
          p = track.scrollLeft / Math.max(1, track.scrollWidth - track.clientWidth);
        }
        meter && meter.style.setProperty('--rp', Math.max(0.06, p).toFixed(3));
      }
      setup(); upd();
      window.addEventListener('resize', function () { setup(); upd(); }, { passive: true });
      window.addEventListener('load', function () { setup(); upd(); });
      onScrollFx(upd);
      track.addEventListener('scroll', upd, { passive: true });
    });
  }

  /* ---------------- shipping + ladder widgets ---------------- */
  function tierFor(n) { var t = null; C.tiers.forEach(function (x) { if (n >= x.n) t = x; }); return t; }
  function nextTier(n) { for (var i = 0; i < C.tiers.length; i++) if (n < C.tiers[i].n) return C.tiers[i]; return null; }
  function paintShip(el, total, mode) {
    if (!el) return;
    var th = C.threshold || 6500, msg = $('[data-ship-msg]', el), sub = $('[data-ship-sub]', el), fl = $('.flacon', el);
    var lvl = clamp(total / th, 0, 1), rem = th - total, html;
    if (!C.shipUS) {
      html = 'Free standard shipping on U.S. orders over <strong>' + money(th, true) + '</strong>';
      if (sub) sub.textContent = 'International rates are calculated at checkout.';
      lvl = 0.5;
    } else if (mode === 'pdp') {
      var base = el.__base || 0;
      if (base >= th) html = 'Your bag already <strong>ships free</strong> in the U.S.';
      else if (rem <= 0) html = 'Add this and your order <strong>ships free</strong> in the U.S.';
      else html = 'Add this and you’re <strong>' + money(rem) + '</strong> from free U.S. shipping';
      if (sub) sub.textContent = 'Free standard U.S. shipping on orders over ' + money(th, true) + '.';
    } else {
      html = rem <= 0 ? 'Your order <strong>ships free</strong> in the U.S. ✦' : 'You’re <strong>' + money(rem) + '</strong> away from free U.S. shipping';
      if (sub) sub.textContent = rem <= 0 ? 'Standard U.S. shipping is on us.' : 'Free standard U.S. shipping on orders over ' + money(th, true) + '.';
    }
    if (msg) msg.innerHTML = html;
    el.style.setProperty('--lvl', lvl.toFixed(3));
    if (fl) { fl.style.setProperty('--lvl', lvl.toFixed(3)); fl.classList.toggle('is-full', lvl >= 1); }
  }
  function paintLadder(el, count) {
    if (!el || !C.tiers.length) return;
    var cur = tierFor(count), nxt = nextTier(count), html = '';
    C.tiers.forEach(function (t, i) {
      var last = i === C.tiers.length - 1;
      html += '<div class="ladder__step' + (cur === t ? ' is-on' : '') + (nxt === t ? ' is-next' : '') + '"><b>−' + money(t.off, true) + '</b><span>' + t.n + (last ? '+' : '') + ' bottles</span></div>';
    });
    var hint;
    if (!nxt) hint = '<strong>Best saving unlocked</strong> — ' + money(cur.off, true) + ' off, applied automatically at checkout.';
    else {
      var need = nxt.n - count;
      hint = (count === 0 ? 'Mix any bottles: ' : 'Add <strong>' + need + ' more</strong> bottle' + (need > 1 ? 's' : '') + ' to save ') + (count === 0 ? '<strong>' + money(C.tiers[0].off, true) + ' off 2</strong>, up to <strong>' + money(C.tiers[C.tiers.length - 1].off, true) + ' off ' + C.tiers[C.tiers.length - 1].n + '+</strong>.' : '<strong>' + money(nxt.off, true) + '</strong>' + (cur ? ' instead of ' + money(cur.off, true) : '') + '.');
    }
    el.innerHTML = html + '<p class="ladder__hint">' + hint + '</p>';
  }

  /* ---------------- cart ---------------- */
  var Cart = {
    state: null,
    get: function () { var s = this; return jfetch((C.routes.cart || '/cart') + '.js').then(function (j) { s.state = j; return j; }); },
    add: function (items, src) {
      var s = this;
      return jfetch((C.routes.add || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { return s.get(); })
        .then(function () {
          s.paint(); s.count(true); burst(src);
          document.dispatchEvent(new CustomEvent('amb:cart', { detail: s.state }));
          if (C.cartType === 'page') { location.href = C.routes.cart || '/cart'; return; }
          setTimeout(function () { s.open(); }, reduce ? 0 : 480);
        });
    },
    change: function (key, q) {
      var s = this;
      return jfetch((C.routes.change || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (j) { s.state = j; s.paint(); s.count(); document.dispatchEvent(new CustomEvent('amb:cart', { detail: j })); if (document.body.classList.contains('tpl-cart')) location.reload(); });
    },
    count: function (pulse) {
      var n = this.state ? this.state.item_count : 0;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('has-items', n > 0); });
      if (pulse) $$('[data-cart-open]').forEach(function (b) { b.classList.remove('bag-pulse'); void b.offsetWidth; b.classList.add('bag-pulse'); });
    },
    open: function () {
      var d = $('[data-drawer]'); if (!d) { location.href = C.routes.cart || '/cart'; return; }
      var s = this;
      (this.state ? Promise.resolve() : this.get()).then(function () { s.paint(); });
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true);
      setTimeout(function () { var x = $('.drawer__x', d); x && x.focus({ preventScroll: true }); }, 400);
    },
    close: function () { var d = $('[data-drawer]'); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lock(false); },
    paint: function () {
      var s = this.state, d = $('[data-drawer]'); if (!s || !d) return;
      $$('[data-cart-count-title]', d).forEach(function (e) { e.textContent = s.item_count; });
      paintShip($('[data-ship]', d), s.total_price);
      paintLadder($('[data-ladder]', d), s.item_count);
      var list = $('[data-cart-items]', d), foot = $('[data-cart-foot]', d), ship = $('[data-ship]', d), lad = $('[data-ladder]', d);
      if (!s.item_count) {
        list.innerHTML = '<div class="cempty">' + STAR.replace('star8', 'star8 cempty__s') + '<p>Your bag awaits its first scent.</p><small>Free standard U.S. shipping on orders over ' + money(C.threshold, true) + '. Mix any 2 bottles and save ' + (C.tiers[0] ? money(C.tiers[0].off, true) : '') + '.</small><a class="btn" href="' + (C.routes.all || '/collections/all') + '">Discover the collection ' + ARROW + '</a></div>';
        foot.hidden = true; ship.hidden = true; lad.hidden = true;
      } else {
        foot.hidden = false; ship.hidden = false; lad.hidden = false;
        list.innerHTML = '<ul class="citems">' + s.items.map(itemHTML).join('') + '</ul>';
      }
      var tot = '';
      if (s.items_subtotal_price !== s.total_price) tot += '<div class="totals__row"><span>Subtotal</span><span>' + money(s.items_subtotal_price) + '</span></div>';
      (s.cart_level_discount_applications || []).forEach(function (a) { tot += '<div class="totals__row totals__row--disc"><span>' + esc(a.title) + '</span><span>−' + money(a.total_allocated_amount) + '</span></div>'; });
      tot += '<div class="totals__row totals__row--main"><span>Total</span><span>' + money(s.total_price) + '</span></div>';
      $('[data-cart-totals]', d).innerHTML = tot;
      Upsell.paint(s);
    }
  };
  function itemHTML(it, i) {
    var vt = it.variant_title && !/default title/i.test(it.variant_title) ? esc(it.variant_title) + ' · ' : '';
    var disc = (it.line_level_discount_allocations || []).map(function (a) { return esc(a.discount_application.title); }).join(', ');
    return '<li class="citem" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
      '<a class="citem__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + img(it.image, 240) + '" alt="' + esc(it.product_title) + '" width="84" height="109" loading="lazy">' : '') + '</a>' +
      '<div><a class="citem__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      '<p class="citem__meta">' + vt + money(it.final_price) + (disc ? ' · ' + disc : '') + '</p>' +
      '<div class="citem__qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div></div>' +
      '<div class="citem__right"><p class="citem__price">' + money(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</p>' +
      '<button type="button" class="citem__rm" data-rm>Remove</button></div></li>';
  }
  function cartUI() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var openB = t.closest('[data-cart-open]');
      if (openB) { e.preventDefault(); Cart.open(); return; }
      if (t.closest('[data-drawer-close]')) { e.preventDefault(); Cart.close(); return; }
      var qb = t.closest('[data-qty]'), rm = t.closest('[data-rm]');
      if (qb || rm) {
        var li = t.closest('[data-key]'); if (!li) return;
        var key = li.getAttribute('data-key');
        var cur = parseInt($('.citem__qty span', li).textContent, 10) || 0;
        var q = rm ? 0 : Math.max(0, cur + parseInt(qb.getAttribute('data-qty'), 10));
        li.classList.add('is-busy');
        Cart.change(key, q).catch(function (err) { li.classList.remove('is-busy'); toast(esc(err.message)); });
        return;
      }
      var qa = t.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        if (qa.classList.contains('is-loading')) return;
        qa.classList.add('is-loading');
        Cart.add([{ id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 }], qa)
          .then(function () { qa.classList.add('is-done'); setTimeout(function () { qa.classList.remove('is-done'); }, 1200); })
          .catch(function (err) { toast(esc(err.message)); })
          .then(function () { qa.classList.remove('is-loading'); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    Cart.get().then(function () {
      Cart.count();
      $$('[data-ship-auto]').forEach(function (el) { paintShip(el, Cart.state.total_price); });
      $$('[data-ladder-auto]').forEach(function (el) { paintLadder(el, Cart.state.item_count); });
      document.dispatchEvent(new CustomEvent('amb:cart', { detail: Cart.state }));
    }).catch(function () {});
    window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.get().then(function () { Cart.count(); Cart.paint(); }); });
  }

  /* upsells: products that close the gap to free shipping first */
  var Upsell = {
    paint: function (s) {
      var box = $('[data-upsell]'); if (!box) return;
      if (!s.item_count) { box.hidden = true; return; }
      catalogue().then(function (d) {
        var inCart = {}; s.items.forEach(function (i) { inCart[i.product_id] = 1; });
        var gap = (C.threshold || 6500) - s.total_price;
        var pool = d.filter(function (p) { return p.available && !inCart[p.id] && p.kind !== 'bundle'; });
        if (!pool.length) { box.hidden = true; return; }
        pool.sort(function (a, b) {
          if (gap > 0) { var fa = a.price >= gap ? 0 : 1, fb = b.price >= gap ? 0 : 1; if (fa !== fb) return fa - fb; return (a.best ? 0 : 1) - (b.best ? 0 : 1) || a.price - b.price; }
          return (a.best ? 0 : 1) - (b.best ? 0 : 1);
        });
        var pick = pool.slice(0, 6);
        $('[data-upsell-sub]', box).textContent = gap > 0 ? 'Any of these ships your order free' : 'Add a bottle, unlock the next saving';
        $('[data-upsell-row]', box).innerHTML = pick.map(function (p) {
          return '<div class="ucard" style="--c-glow:' + esc(p.glow || '#e6cc8a') + '"><a class="mini__arch" href="' + esc(p.url) + '"><img src="' + img(p.img, 300) + '" alt="' + esc(p.title) + '" loading="lazy" width="140" height="182"></a>' +
            '<a class="ucard__t" href="' + esc(p.url) + '">' + esc(p.name || p.title) + '</a><div class="ucard__row"><span class="ucard__p">' + money(p.price) + '</span>' +
            '<button type="button" class="ucard__add" data-quick-add="' + p.vid + '" aria-label="Add ' + esc(p.title) + ' to bag">' + PLUS + '</button></div></div>';
        }).join('');
        box.hidden = false;
      });
    }
  };

  /* atomizer burst: a golden mist flies from the button into the bag */
  function burst(src) {
    if (reduce || !src || !src.getBoundingClientRect) return;
    var r = src.getBoundingClientRect(), bag = $('.hdr [data-cart-open]'), br = bag ? bag.getBoundingClientRect() : { left: innerWidth - 60, top: 30, width: 0, height: 0 };
    var dpr = Math.min(devicePixelRatio || 1, 2), cv = document.createElement('canvas'); cv.className = 'burst';
    cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; cv.style.width = innerWidth + 'px'; cv.style.height = innerHeight + 'px';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr); ctx.globalCompositeOperation = 'lighter';
    var sx = r.left + r.width / 2, sy = r.top + r.height / 2, tx = br.left + br.width / 2, ty = br.top + br.height / 2;
    var ps = []; for (var i = 0; i < 80; i++) ps.push({ x: sx + (Math.random() - .5) * r.width * .6, y: sy, vx: (Math.random() - .5) * 7, vy: -Math.random() * 7 - 1, l: 0, m: 46 + Math.random() * 40, s: .8 + Math.random() * 2.6, d: Math.random() * 12 });
    var f = 0;
    (function step() {
      f++; ctx.clearRect(0, 0, innerWidth, innerHeight); var alive = 0;
      for (var j = 0; j < ps.length; j++) {
        var p = ps[j]; if (f < p.d) { alive++; continue; }
        p.l++; var k = p.l / p.m; if (k >= 1) continue; alive++;
        var pull = k * k * 0.018;
        p.vx = p.vx * 0.93 + (tx - p.x) * pull; p.vy = p.vy * 0.93 + (ty - p.y) * pull;
        p.x += p.vx; p.y += p.vy;
        var a = Math.sin(Math.PI * k), rad = p.s * (3 - k * 1.5);
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, rad * 2.2);
        g.addColorStop(0, 'rgba(250,236,196,' + (0.95 * a).toFixed(3) + ')'); g.addColorStop(.4, 'rgba(230,204,138,' + (0.55 * a).toFixed(3) + ')'); g.addColorStop(1, 'rgba(201,162,75,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, rad * 2.2, 0, 6.283); ctx.fill();
      }
      if (alive) raf(step); else cv.remove();
    })();
  }

  /* ---------------- product page ---------------- */
  function product() {
    var root = $('[data-pdp]'); if (!root) return;
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var P = JSON.parse(jsonEl.textContent), form = $('[data-product-form]', root);
    var idInput = form && $('input[name=id]', form), btn = form && $('[data-add]', form), qtyIn = form && $('input[name=quantity]', form);
    var priceEl = $('[data-price]', root), compEl = $('[data-compare]', root), saveEl = $('[data-save]', root), stockEl = $('[data-stock]', root);
    var sticky = $('[data-sticky]'), offer = $('[data-offer]', root);
    var current = P.variants.filter(function (v) { return v.id === parseInt(idInput && idInput.value, 10); })[0] || P.variants[0];

    function paintVariant(v) {
      current = v;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compEl) { compEl.hidden = !(v.compare_at_price > v.price); compEl.textContent = money(v.compare_at_price || 0); }
      if (saveEl) { saveEl.hidden = !(v.compare_at_price > v.price); saveEl.textContent = 'Save ' + money((v.compare_at_price || 0) - v.price); }
      if (btn) { btn.disabled = !v.available; $('span', btn).textContent = v.available ? btn.getAttribute('data-label') : 'Sold out'; }
      $$('[data-sticky-price]').forEach(function (e) { e.textContent = money(v.price); });
      if (history.replaceState && P.variants.length > 1) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      if (v.featured_media) goTo(v.featured_media.id);
      offerPaint();
    }
    $$('[data-opt]', root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = $$('[data-opt]:checked', root).map(function (i) { return i.value; });
        var v = P.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
        if (v) paintVariant(v);
      });
    });
    $$('[data-q]', root).forEach(function (b) {
      b.addEventListener('click', function () { qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + parseInt(b.getAttribute('data-q'), 10)); offerPaint(); });
    });
    qtyIn && qtyIn.addEventListener('change', offerPaint);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      Cart.add([{ id: current.id, quantity: parseInt(qtyIn.value, 10) || 1 }], btn)
        .catch(function (err) { toast(esc(err.message)); })
        .then(function () { btn.classList.remove('is-loading'); });
    });
    if (sticky && btn) {
      $('[data-sticky-add]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : btn.click(); });
      new IntersectionObserver(function (es) {
        var e = es[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
    function offerPaint() {
      if (!offer) return;
      var s = Cart.state || { total_price: 0, item_count: 0 }, q = parseInt(qtyIn && qtyIn.value, 10) || 1;
      var ship = $('[data-ship]', offer);
      if (ship) { ship.__base = s.total_price; paintShip(ship, s.total_price + current.price * q, 'pdp'); }
      paintLadder($('[data-ladder]', offer), s.item_count + q);
    }
    document.addEventListener('amb:cart', offerPaint);
    offerPaint();

    /* gallery */
    var slides = $$('.pdp__slide', root), thumbs = $$('.pdp__thumb', root), dots = $$('.pdp__dots button', root), idx = 0, arch = $('.pdp__arch', root);
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx); });
      dots.forEach(function (t, k) { t.setAttribute('aria-current', k === idx); });
      arch && arch.classList.remove('is-zoom');
    }
    function goTo(mediaId) { slides.forEach(function (s, k) { if (parseInt(s.getAttribute('data-media'), 10) === mediaId) show(k); }); }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    dots.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    $$('[data-g-prev]', root).forEach(function (b) { b.addEventListener('click', function () { show(idx - 1); }); });
    $$('[data-g-next]', root).forEach(function (b) { b.addEventListener('click', function () { show(idx + 1); }); });
    if (arch) {
      var x0 = null, moved = false;
      arch.addEventListener('pointerdown', function (e) { x0 = e.clientX; moved = false; });
      arch.addEventListener('pointerup', function (e) {
        if (x0 == null) return; var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { moved = true; show(idx + (dx < 0 ? 1 : -1)); }
      });
      arch.addEventListener('click', function (e) {
        if (moved || !fine) return;
        arch.classList.toggle('is-zoom'); zoomAt(e);
      });
      arch.addEventListener('pointermove', zoomAt);
      arch.addEventListener('pointerleave', function () { arch.classList.remove('is-zoom'); });
      function zoomAt(e) {
        if (!arch.classList.contains('is-zoom')) return;
        var r = arch.getBoundingClientRect(), s = slides[idx];
        s.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      }
    }
    setTimeout(function () { slides.forEach(function (s) { s.classList.remove('is-vt'); }); }, 1500);

    /* colour each note orb by what it smells of */
    var NOTE = [['rose','#e38a9e'],['vanilla','#f3e2b3'],['oud','#7a5230'],['agarwood','#7a5230'],['bergamot','#d8e27a'],['lemon','#f5e050'],['lime','#b6e05a'],['mint','#9fe0c0'],
      ['amber','#e0a040'],['musk','#efe6f5'],['sandal','#c8a070'],['cedar','#a07a52'],['wood','#9a7a55'],['jasmine','#fff1c8'],['pineapple','#f2c94c'],['apple','#b5d86a'],['pear','#d9e08a'],
      ['cinnamon','#b0602a'],['coffee','#6f4e37'],['chocolate','#5a3a26'],['cacao','#5a3a26'],['caramel','#c98a3e'],['praline','#c08a50'],['tonka','#b88a5a'],['patchouli','#6b5a3a'],
      ['saffron','#e0782a'],['pepper','#b0522d'],['cardamom','#a8c07a'],['lavender','#b39ddb'],['iris','#9fa8da'],['orchid','#d98cc8'],['peach','#f7b58a'],['mango','#f5a623'],
      ['coconut','#f5efe0'],['strawberr','#e8485a'],['cherry','#a0142a'],['plum','#7d3a6a'],['marshmallow','#fbe3ec'],['orange','#f39c3c'],['mandarin','#f39c3c'],['tangerine','#f5a03c'],
      ['grapefruit','#f28b82'],['citrus','#f5c542'],['sea','#5fb8d8'],['water','#6cc3e0'],['aquatic','#5fb8d8'],['marine','#4aa8d0'],['leather','#6a4a3a'],['incense','#8a7f7a'],
      ['myrrh','#8a5a3a'],['honey','#e8b04a'],['gardenia','#fff6dc'],['tuberose','#fff0e8'],['heliotrope','#c9a0dc'],['violet','#8e6cc8'],['lily','#fbf3e6'],['lotus','#f4c6d8'],
      ['fig','#8a6a8a'],['melon','#c8e6a0'],['watermelon','#f06b7a'],['passion','#e8a33a'],['berr','#b0305a'],['currant','#5a1a3a'],['pistachio','#a6c47a'],['almond','#e8d4b0'],
      ['tea','#b89a5a'],['sage','#9ab08a'],['ginger','#e0b050'],['spic','#c0602a'],['smok','#8a8078'],['birch','#8a8078'],['moss','#6a7a4a'],['labdanum','#a0703a'],['ambergris','#d8c8a0'],
      ['rum','#a0602a'],['bourbon','#b0702a'],['tobacco','#8a5a2a'],['benzoin','#c0904a'],['neroli','#fff0c0'],['blossom','#fff3d6'],['floral','#f3c3d4'],['fruit','#f09a6a'],['sugar','#fbeede'],['candy','#f58ab0'],['gourmand','#d8a060']];
    $$('.note', root).forEach(function (n) {
      var t = n.textContent.toLowerCase();
      for (var k = 0; k < NOTE.length; k++) { if (t.indexOf(NOTE[k][0]) > -1) { n.style.setProperty('--o', NOTE[k][1]); break; } }
    });

    /* scroll: atmosphere veil + composition timeline */
    var comp = $('.comp', root);
    onScrollFx(function () {
      var v = clamp(scrollY / (innerHeight * 0.9), 0, 1);
      root.style.setProperty('--veil', v.toFixed(3));
      if (comp) {
        var r = comp.getBoundingClientRect();
        comp.style.setProperty('--prog', clamp((innerHeight * 0.8 - r.top) / (r.height + innerHeight * 0.2), 0, 1).toFixed(3));
      }
    });
  }

  /* ---------------- ritual (offer) stepper ---------------- */
  function ritual() {
    $$('[data-ritual]').forEach(function (root) {
      var btns = $$('[data-n]', root), bottles = $$('.bottle', root), save = $('[data-save-n]', root), msg = $('[data-save-msg]', root), shown = 0, auto = true, timer;
      function set(n) {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-n'), 10) === n)); });
        bottles.forEach(function (b, i) { b.classList.toggle('is-on', i < n); });
        var t = tierFor(n), to = t ? t.off : 0, from = shown; shown = to;
        tween(from, to, 900, function (v) { save.textContent = to === 0 ? '—' : '−' + money(Math.round(v / 100) * 100, true); });
        var nx = nextTier(n);
        msg.innerHTML = n < 2 ? 'One bottle ships free once your order reaches <strong>' + money(C.threshold, true) + '</strong>. Add a second to start saving.'
          : (nx ? '<strong>' + money(to, true) + ' off</strong> your order, automatically. One more bottle takes it to <strong>' + money(nx.off, true) + '</strong>.'
            : '<strong>' + money(to, true) + ' off</strong> — the best saving. Most bundles of this size ship free, too.');
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { auto = false; clearInterval(timer); set(parseInt(b.getAttribute('data-n'), 10)); }); });
      set(2);
      if (!reduce) {
        var n = 2;
        new IntersectionObserver(function (es) {
          clearInterval(timer);
          if (es[0].isIntersecting && auto) timer = setInterval(function () { n = n >= 4 ? 1 : n + 1; set(n); }, 2400);
        }, { threshold: 0.4 }).observe(root);
      }
    });
  }

  /* ---------------- scent finder ---------------- */
  var FINDER = [
    { k: 'for', q: 'Who will wear it?', o: [
      { v: 'him', b: 'For him', s: 'Bold woods, spice and smoke', ar: 'له' },
      { v: 'her', b: 'For her', s: 'Florals, fruit and soft sweetness', ar: 'لها' },
      { v: 'all', b: 'For anyone', s: 'Unisex signatures to share', ar: 'للجميع' }] },
    { k: 'mood', q: 'Which mood draws you in?', o: [
      { v: 'fresh', b: 'Fresh & clean', s: 'Citrus, sea air, crisp mint', t: ['fresh', 'aquatic', 'citrus'] },
      { v: 'sweet', b: 'Sweet & cozy', s: 'Vanilla, praline, caramel', t: ['sweet', 'gourmand', 'vanilla'] },
      { v: 'dark', b: 'Dark & smoky', s: 'Oud, incense, deep woods', t: ['oud', 'woody', 'amber'] },
      { v: 'floral', b: 'Floral & romantic', s: 'Rose, jasmine, soft musk', t: ['floral', 'musk', 'fruity'] },
      { v: 'spicy', b: 'Warm & spicy', s: 'Amber, saffron, cinnamon', t: ['spicy', 'amber', 'woody'] }] },
    { k: 'time', q: 'When will you wear it most?', o: [
      { v: 'Day', b: 'By day', s: 'Office, errands, sunshine' },
      { v: 'Night', b: 'After dark', s: 'Dinners, dates, evenings out' },
      { v: 'both', b: 'Day & night', s: 'One signature for everything' }] }
  ];
  function finder() {
    $$('[data-finder]').forEach(function (root) {
      var stage = $('[data-finder-stage]', root), dots = $$('.finder__dots i', root), ans = {}, step = 0;
      function paint() {
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i <= step); });
        if (step >= FINDER.length) return results();
        var s = FINDER[step];
        stage.innerHTML = '<div class="finder__stage"><p class="finder__q">' + esc(s.q) + '</p><div class="finder__opts">' + s.o.map(function (o) {
          return '<button type="button" class="fopt" data-v="' + o.v + '">' + (o.ar ? '<i>' + o.ar + '</i>' : '') + '<b>' + esc(o.b) + '</b><span>' + esc(o.s) + '</span></button>';
        }).join('') + '</div>' + (step ? '<div class="finder__again"><button type="button" class="link-line" data-back>Back</button></div>' : '') + '</div>';
      }
      stage.addEventListener('click', function (e) {
        var o = e.target.closest('[data-v]');
        if (o) { ans[FINDER[step].k] = o.getAttribute('data-v'); step++; paint(); catalogue(); return; }
        if (e.target.closest('[data-back]')) { step = Math.max(0, step - 1); paint(); return; }
        if (e.target.closest('[data-restart]')) { step = 0; ans = {}; paint(); }
      });
      function results() {
        stage.innerHTML = '<div class="finder__stage"><p class="finder__q">Composing your matches…</p></div>';
        catalogue().then(function (d) {
          var mood = FINDER[1].o.filter(function (o) { return o.v === ans.mood; })[0];
          var scored = d.filter(function (p) { return p.available && p.kind !== 'bundle'; }).map(function (p) {
            var tags = p.tags || [], sc = 0;
            if (ans.for === 'him') sc += tags.indexOf('men') > -1 ? 4 : (tags.indexOf('unisex') > -1 ? 2 : -6);
            if (ans.for === 'her') sc += tags.indexOf('women') > -1 ? 4 : (tags.indexOf('unisex') > -1 ? 2 : -6);
            if (ans.for === 'all') sc += tags.indexOf('unisex') > -1 ? 4 : 1;
            (mood ? mood.t : []).forEach(function (t, i) { if (tags.indexOf(t) > -1) sc += 3 - i * 0.5; });
            if (ans.time !== 'both') { if (p.time === ans.time) sc += 2; else if (p.time === 'Day & Night') sc += 1; else sc -= 1; }
            else if (p.time === 'Day & Night') sc += 1.5;
            if (p.best) sc += 0.8;
            return { p: p, s: sc };
          }).sort(function (a, b) { return b.s - a.s; });
          var top = scored.slice(0, 3), best = top.length ? top[0].s : 1;
          stage.innerHTML = '<div class="finder__stage"><p class="finder__q">Your signature trio</p><div class="finder__res">' + top.map(function (r, i) {
            var p = r.p, pct = Math.round(clamp(78 + (r.s / Math.max(best, 1)) * 20 - i * 2, 70, 98));
            return '<article class="res" style="--i:' + i + ';--c-glow:' + esc(p.glow || '#e6cc8a') + '"><a class="mini__arch" href="' + esc(p.url) + '"><img src="' + img(p.img, 400) + '" alt="' + esc(p.title) + '" loading="lazy" width="200" height="260"></a><div style="display:grid;gap:8px"><p class="res__match">' + pct + '% match</p><a class="res__t" href="' + esc(p.url) + '">' + esc(p.name || p.title) + '</a><p class="res__tag">' + esc(p.tagline || '') + '</p><div class="res__row"><span class="res__p">' + money(p.price) + '</span><button type="button" class="btn btn--sm" data-quick-add="' + p.vid + '">Add</button></div></div></article>';
          }).join('') + '</div><div class="finder__again"><button type="button" class="link-line" data-restart>Start again</button><a class="link-line" href="' + (C.routes.all || '/collections/all') + '">Browse everything</a></div></div>';
        });
      }
      paint();
    });
  }

  /* ---------------- collection: instant filtering + sort ---------------- */
  function collection() {
    var root = $('[data-coll]'); if (!root) return;
    function load(url, push) {
      var body = $('[data-coll-body]', root), grid = $('.coll__grid', root);
      grid && grid.classList.add('is-loading');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), nb = $('[data-coll] [data-coll-body]', doc);
        if (!nb) { location.href = url; return; }
        body.innerHTML = nb.innerHTML;
        var nh = $('[data-coll] .coll__count', doc), oh = $('.coll__count', root); if (nh && oh) oh.textContent = nh.textContent;
        if (push) history.pushState({ amb: 1 }, '', url);
        document.title = doc.title;
        reveals(body); magnetic(body);
        var bar = $('.coll__bar', root); if (bar && bar.getBoundingClientRect().top < 0) window.scrollTo({ top: scrollY + bar.getBoundingClientRect().top - 10, behavior: reduce ? 'auto' : 'smooth' });
      }).catch(function () { location.href = url; });
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-pjax]'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); load(a.href, true);
    });
    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-sort]'); if (!s) return;
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); load(u.toString(), true);
    });
    window.addEventListener('popstate', function () { load(location.href, false); });
  }

  /* ---------------- predictive search ---------------- */
  function search() {
    var o = $('[data-search]'); if (!o) return;
    var input = $('input[type=search]', o), out = $('[data-search-results]', o), def = $('[data-search-default]', o), t, ctrl;
    function open() { o.classList.add('is-open'); o.setAttribute('aria-hidden', 'false'); lock(true); setTimeout(function () { input.focus(); }, 120); }
    function close() { o.classList.remove('is-open'); o.setAttribute('aria-hidden', 'true'); lock(false); }
    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-search-close]', o).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && o.classList.contains('is-open')) close();
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); o.classList.contains('is-open') ? close() : open(); }
    });
    $$('[data-q-chip]', o).forEach(function (c) { c.addEventListener('click', function () { input.value = c.getAttribute('data-q-chip'); run(); }); });
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 200); });
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { out.hidden = true; def.hidden = false; return; }
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      var url = (C.routes.predict || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j.resources && j.resources.results) || {}, ps = res.products || [], cs = res.collections || [], qs = res.queries || [];
        var html = '';
        if (qs.length) html += '<div class="srch__chips">' + qs.slice(0, 5).map(function (x) { return '<a class="chip" href="' + esc(x.url) + '">' + esc(x.text) + '</a>'; }).join('') + '</div>';
        if (ps.length) {
          html += '<p class="srch__label">Fragrances</p><div class="srch__grid">' + ps.map(function (p, i) {
            var im = p.image || (p.featured_image && p.featured_image.url) || '';
            var price = p.price != null ? money(String(p.price).indexOf('.') > -1 ? String(p.price) : Number(p.price)) : '';
            return '<a class="mini" style="--i:' + i + '" href="' + esc(p.url) + '"><span class="mini__arch">' + (im ? '<img src="' + img(im, 360) + '" alt="" loading="lazy">' : '') + '</span><span class="mini__t">' + esc(p.title) + '</span><span class="mini__p">' + price + '</span></a>';
          }).join('') + '</div>';
        }
        if (cs.length) html += '<p class="srch__label" style="margin-top:36px">Collections</p><div class="srch__cols">' + cs.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
        if (!ps.length && !cs.length) html = '<p class="srch__empty">Nothing yet for “' + esc(q) + '”. Try a note — oud, vanilla, rose — or a house like Lattafa.</p>';
        html += '<div class="srch__all"><a class="btn btn--ghost" href="' + (C.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product">See all results ' + ARROW + '</a></div>';
        out.innerHTML = html; out.hidden = false; def.hidden = true;
      }).catch(function () {});
    }
  }

  /* ---------------- view transition: card image → product image ---------------- */
  function vt() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.card__link,a.mini,.hero__arch a'); if (!a || e.metaKey || e.ctrlKey) return;
      $$('.card__img,.mini__arch img').forEach(function (i) { i.style.viewTransitionName = ''; });
      var im = a.querySelector('.card__img:not(.card__img--alt),.mini__arch img'); if (im) im.style.viewTransitionName = 'amb-pimg';
    }, true);
    window.addEventListener('pageshow', function () { $$('.card__img,.mini__arch img').forEach(function (i) { i.style.viewTransitionName = ''; }); });
  }

  /* ---------------- count-up numbers ---------------- */
  function counters(root) {
    $$('[data-count]', root).forEach(function (el) {
      if (el.__c) return; el.__c = 1;
      var to = parseFloat(el.getAttribute('data-count')), dec = (el.getAttribute('data-count').split('.')[1] || '').length;
      new IntersectionObserver(function (es, ob) {
        if (!es[0].isIntersecting) return; ob.disconnect();
        tween(0, to, 1600, function (v) { el.textContent = v.toFixed(dec); });
      }).observe(el);
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    intro(); header(); reveals(); parallax(); manifesto(); footerWord(); cursor(); magnetic(); tilt(); rails();
    cartUI(); product(); ritual(); finder(); collection(); search(); vt(); counters();
    window.__ambRunScroll && window.__ambRunScroll();
  }
  window.Amb = { cart: Cart, money: money, toast: toast, reveals: reveals, catalogue: catalogue };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { reveals(e.target); magnetic(e.target); counters(e.target); ritual(); finder(); rails(); manifesto(); });
})();
